module.exports = __webpack_public_path__ + "static/img/logo9.1571a8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo9.svg
// module id = y/rE
// module chunks = 19